import React from "react";
import PropTypes from "prop-types";
import style from "./ExercisesBar.module.sass";

function ExercisesBar(props) {
  const {
    colors,
    exercises,
    label,
    noBorder,
    showPain,
    maxVisible = 20,
    myLink
  } = props;

  const total = exercises.length;
  const remaining = total - maxVisible;

  const backgroundColorStyle = (exercise) => {
    if (exercise.pain_value) return '#FF4F4F';
    if (['interrupted', 'skipped'].includes(exercise.state)) return '#11151A';
    if (exercise.state) return colors.primaryColor;
    return '#161B21';
  };

  const pain = (exercise) => {
    return exercise.pain_value > 0 && showPain ? exercise.pain_value : "";
  };

  let rootClass = `${style.ExercisesBar}`;
  if (noBorder) rootClass += ` ${style["ExercisesBar--noBorder"]}`;

  const displayed = exercises.slice(0, maxVisible);

  return (
    <div className={rootClass}>
      {displayed.map((exercise, index) => (
        <div key={`${label}-${index}-${exercise.id}`} className={`${style.itemWrapper} ${myLink ? style.itemWrapperMyLink : ""}`}>
          <div
             className={`${style.item} ${myLink ? style.itemMyLink : ""}`}
            style={{ backgroundColor: backgroundColorStyle(exercise) }}
          >
            {showPain && <div className={style.painLabel}>{pain(exercise)}</div>}
          </div>
        </div>
      ))}
      {remaining > 0 && (
        <div className={style.extraCount}>+{remaining}</div>
)     }
    </div>
  );
}

ExercisesBar.propTypes = {
  exercises: PropTypes.array,
  maxVisible: PropTypes.number,
};

ExercisesBar.defaultProps = {
  showPain: false,
  noBorder: false,
  exercises: [],
  maxVisible: 20,
};

export default ExercisesBar;
